import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from '../../../../styles.scss'

class Status extends Component {
    constructor(props) {
        super(props)

        this.state = { timer: null, showText: false }
    }

    componentDidMount() {
        if (this.props.changeCount > 0) {
            this.reset()
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.changeCount > 0 && this.props.changeCount !== prevProps.changeCount) {
            this.reset()
        }
    }

    componentWillUnmount() {
        clearTimeout(this.state.timer)
    }

    reset = () => {
        if (this.state.timer != null) {
            clearTimeout(this.state.timer)
        }
        const timer = setTimeout(this.hide, this.props.timeout)
        this.setState({ timer, showText: true })
    }

    hide = () => {
        this.setState({ showText: false })
    }

    render() {
        const style = {
            opacity: 0,
            transition: `opacity ${this.props.fadeDuration}ms ease-out`,
        }

        if (this.state.showText) {
            style.opacity = 1
            style.transition = `opacity ${this.props.fadeDuration}ms ease-out`
        }

        return (
            <div className={styles.status} style={style}>
                {`${this.props.text} ✔`}
            </div>
        )
    }
}

Status.propTypes = {
    text: PropTypes.string,
    changeCount: PropTypes.number,
    fadeDuration: PropTypes.number,
    timeout: PropTypes.number,
}

Status.defaultProps = {
    changeCount: 0,
    fadeDuration: 1000,
    timeout: 5000,
}

export default Status



// WEBPACK FOOTER //
// ./src/features/Settings/components/Settings/components/Status/component.js